import { Card, Table, Tag, Switch, message, Button } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { $ } from '../../lib/api';

export function AdminAiConfigsPage() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ['ai-configs'], queryFn: () => $.get<any[]>('/ai/configs') });
  const { data: health } = useQuery({ queryKey: ['ai-health'], queryFn: () => $.get('/ai/providers/health') });
  const toggle = useMutation({
    mutationFn: ({ id, enabled }: any) => $.put(`/ai/configs/${id}`, { enabled: enabled ? 1 : 0 }),
    onSuccess: () => { message.success('已更新'); qc.invalidateQueries({ queryKey: ['ai-configs'] }); },
  });
  return (
    <div>
      <Card title="AI 网关状态" style={{ marginBottom: 16 }}>
        <p>当前模式：<Tag color={health?.mode === 'live' ? 'green' : 'orange'}>{health?.mode ?? 'mock'}</Tag></p>
        <div>
          {health?.providers?.map((p: any) => (
            <Tag key={p.name} color={p.configured ? 'green' : 'default'}>{p.name}: {p.configured ? '已配置' : '未配置'}</Tag>
          ))}
        </div>
      </Card>
      <Card title="15+ AI 功能配置（管理员可单独切换 provider/model）">
        <Table
          rowKey="featureKey"
          loading={isLoading}
          dataSource={data ?? []}
          pagination={false}
          columns={[
            { title: '功能', dataIndex: 'featureName' },
            { title: 'Feature Key', dataIndex: 'featureKey' },
            { title: 'Provider', dataIndex: 'provider', render: (v: string) => <Tag>{v}</Tag> },
            { title: '模型', dataIndex: 'model' },
            { title: '本月已花', dataIndex: 'currentMonthSpent', render: (v: any) => `¥${v}` },
            { title: '预算', dataIndex: 'monthlyBudgetCny', render: (v: any) => v ? `¥${v}` : '—' },
            { title: '启用', dataIndex: 'enabled', render: (v: any, r: any) =>
              <Switch checked={!!v} onChange={(e) => toggle.mutate({ id: r.id, enabled: e })} /> },
          ]}
        />
      </Card>
    </div>
  );
}
